import React, { useRef, useState } from 'react';

// Latest feed entry: left-swipe (>= 70px) or 600ms hold = undo; clean tap = edit.
export function RecentEntryWithGestures({ children, onUndo, onTap, testId }) {
  const startX = useRef(0);
  const startY = useRef(0);
  const moved = useRef(false);
  const longPressTimer = useRef(null);
  const cancelled = useRef(false);
  const [dx, setDx] = useState(0);

  const cancelTimer = () => {
    if (longPressTimer.current) {
      clearTimeout(longPressTimer.current);
      longPressTimer.current = null;
    }
  };

  const onPointerDown = (e) => {
    moved.current = false;
    cancelled.current = false;
    startX.current = e.clientX;
    startY.current = e.clientY;
    cancelTimer();
    longPressTimer.current = setTimeout(() => {
      if (!cancelled.current && !moved.current) {
        onUndo();
        cancelled.current = true;
      }
    }, 600);
  };
  const onPointerMove = (e) => {
    if (cancelled.current) return;
    const cdx = e.clientX - startX.current;
    const cdy = e.clientY - startY.current;
    if (Math.abs(cdx) > 6 || Math.abs(cdy) > 6) {
      moved.current = true;
      cancelTimer();
    }
    if (Math.abs(cdy) < 40 && cdx < 0) setDx(Math.max(cdx, -140));
  };
  const onPointerUp = (e) => {
    cancelTimer();
    setDx(0);
    if (cancelled.current) return;
    const cdx = e.clientX - startX.current;
    const cdy = e.clientY - startY.current;
    if (cdx <= -70 && Math.abs(cdy) < 40) onUndo();
    else if (!moved.current && onTap) onTap();
  };
  const onPointerCancel = () => {
    cancelTimer();
    cancelled.current = true;
    setDx(0);
  };

  const swipeStrength = Math.min(Math.abs(dx) / 100, 1);
  return (
    <div className="relative" data-testid={testId}>
      <div
        className="absolute inset-0 flex items-center justify-end pr-4 rounded-lg pointer-events-none"
        style={{
          background: `linear-gradient(to left, rgba(244,63,94,${0.18 * swipeStrength}), transparent 60%)`,
          opacity: swipeStrength,
        }}>
        <span className="text-xs uppercase tracking-widest text-rose-300 font-bold">undo</span>
      </div>
      <div
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerCancel}
        style={{ transform: `translateX(${dx}px)`, touchAction: 'pan-y' }}
        className="relative transition-transform select-none">
        {children}
      </div>
    </div>
  );
}
